
export class Logger {

    static isDebug = process.env.NEXT_PUBLIC_ENV === 'dev';
    static isVerbose = false;

    static error(e: any, message?: string) {
        if (message) {
            console.error(message, e)
        } else {
            console.log(e);
        }
    }

    static async debugPerformanceAsync<T>(functionName: string, invoke: () => Promise<T>) {

        if (!this.isDebug) {
            return await invoke();
        }

        let startTime: Date = new Date();
        const result = await invoke();

        let endTime: Date = new Date();
        var timeDiffMs = endTime.getTime() - startTime.getTime(); //in ms

        console.log(`PERF - ${functionName} took ${timeDiffMs}ms`)

        return result;
    }

    static debug(message: string, ...optionalParams: any[]) {
        if (this.isDebug) {
            if (optionalParams && optionalParams.length > 0) {
                console.log(`DEBUG - ${message}`, optionalParams.length === 1 ? optionalParams[0] : optionalParams)
            } else {
                console.log(`DEBUG - ${message}`)
            }

        }
    }

    static verbose(message: string, ...optionalParams: any[]) {
        if (this.isVerbose) {
            if (optionalParams && optionalParams.length > 0) {
                console.log(`VERBOSE - ${message}`, optionalParams.length === 1 ? optionalParams[0] : optionalParams)
            } else {
                console.log(`VERBOSE - ${message}`)
            }

        }
    }



}
